<template>
  <el-dialog
    :visible.sync="visible"
    append-to-body
    :show-close="true"
    :center="true"
    :before-close="handleClose"
    title="创建社团"
    width="500px"
    
  >
    <div>
      <el-form ref="form" :model="formData"  :rules="rules" label-width="100px" label-position="top"	>
        <el-form-item label="社团名称	" prop="title" >  
          <el-input  type="text" v-model="formData.title"  ></el-input> 
        </el-form-item>


        <el-form-item label="社团LOGO" prop="logo_image" >
          <imageUpload v-model="formData.logo_image"/>

        </el-form-item>


        <el-form-item label="社团简介" prop="content">
          <el-input type="textarea" v-model="formData.content"></el-input>
        </el-form-item>

        <el-form-item label="所属类型"  prop="type" >
          <el-radio-group v-model="formData.type" size="small">
            <el-radio label="1" >平台</el-radio>
            <el-radio label="2" >企业</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="社团所属企业" prop="company_app_id" v-if="formData.type==2">
          <el-select v-model="formData.company_app_id" placeholder="请选择">
              <el-option v-for=" ( item,index) in companyDataList" :key="index" :label="item.company_name" :value="item.company_app_id" >
              </el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取 消</el-button>
      <el-button type="primary" @click="submit">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { companyList,corporationAdd } from "@/api/community/index.js";

import FileUpload from '@/components/FileUpload';
import ImageUpload from '@/components/ImageUpload';

export default {
  components: {
    FileUpload,ImageUpload
  },
  data() {
    return {
      visible: false,

      companyDataList:[],
      formData: {
        title:"",
        content: "",
        type: "",//类型，1平台，2企业
        logo_image:"",
        company_app_id: "",
       
      },
       rules: {
        title: [
              {required: true, message: '请输入社团名称', trigger: 'change'}
          ],

          logo_image: [
              {required: true, message: '请上传社团LOGO', trigger: 'blur'}
          ],
          
          content: [
              {required: true, message: '请输入社团简介', trigger: 'blur'}
          ],

          type: [
              {required: true, message: '请输入招聘人数', trigger: 'blur'}
          ]

         
       }
    };
  },

 

  
  methods: {
    handleClose() {
      this.$refs["form"].resetFields();

      this.visible = false;

    },


    init() {
      this.visible = true;
      this.initComp();
    },

    initComp(){
      companyList({}).then((response) => {
              console.log(response);
              if(response.code==200){
                this.companyDataList=response.data;
              
              }else{
                this.$message({
                  message: response.msg?response.msg:"获取信息失败",
                });
              }
            });
    },
    
    
    submit(){
      var that=this;
     

      this.$refs["form"].validate((valid) => {
          if (valid) {
            corporationAdd(that.formData).then((response) => {
              console.log(response);
              if(response.code==200){
                this.$message({
                   message: "提交成功",
                   type: 'success'

                });
                that.$emit('refresh');
                that.visible = false;
              
              }else{
                this.$message({
                  message: response.msg?response.msg:"提交失败",
                });
              }
            });
          } 
        });

    },

    
  },

 
};
</script>

<style lang="scss" scoped>



::v-deep .myWindow {
    border-radius: 15px;



.el-button--primary {
  color: #FFF;
  background-color: #717ebb;
  border-color: #717ebb;
}


/*
.footer{
  display: flex;
  justify-content: center;
}*/


  }
</style>
